import Header from './Header';
import Intro from './Intro';

const components = {
  Header,
  Intro
}


export default components;
